

































































































































































































































import LayoutReportStep from "@/layouts/LayoutReportStep.vue";
import { IReportHeaderData } from "@/lib/interfaces/Report/IReportHeaderData";
import { IReportStep } from "@/lib/interfaces/Report/IViewReportStep";
import { emailRule, phoneRule, noNumberRule, germanZipRule } from "@/lib/rules/contactRule";
import { ibanRule } from "@/lib/rules/ibanRule";
import { numberplateRule } from "@/lib/rules/numberplateRule";
import { requiredRule } from "@/lib/rules/requiredRule";
import { ThgCreateModule } from "@/store/modules/thg.create.store";
import { UserModule } from "@/store/modules/user.store";
import { Component, Vue } from "vue-property-decorator";
import { noWhiteSpaceRule } from "@/lib/rules/noWhiteSpaceRule";
import { ReportModule } from "@/store/modules/report.store";

@Component({
  components: {
    LayoutReportStep
  }
})
export default class ThgContactData extends Vue implements IReportStep {
  public md = 4;

  public isResubmittingAddressDetails = false;

  // Getters
  get header(): IReportHeaderData {
    if (!this.isAuthenticated) {
      return {
        title: "report.thgContactData.notAuthenticatedTitle",
        description: "report.thgContactData.notAuthenticatedDescription"
      };
    } else {
      return {
        title: "report.thgContactData.title",
        description: "report.thgContactData.description"
      };
    }
  }

  get isAuthenticated() {
    return UserModule.isAuthenticated;
  }

  get showBankingInfo(): boolean {
    return ThgCreateModule.showBankingInfo;
  }

  get numberplate(): string {
    return ThgCreateModule.numberplate;
  }

  get user(): any {
    return ThgCreateModule.user;
  }

  get contact(): any {
    return ThgCreateModule.contact;
  }

  get address(): any {
    return ThgCreateModule.address;
  }

  get banking(): any {
    return ThgCreateModule.banking;
  }

  get company(): any {
    return ThgCreateModule.company;
  }

  get taxnumber(): any {
    return ThgCreateModule.taxnumber;
  }

  get isCompany(): boolean {
    return ThgCreateModule.isCompany;
  }

  set isCompany(isCompany: boolean) {
    ThgCreateModule.setIsCompany(isCompany);
  }

  get isResubmitAddress(): boolean {
    return ThgCreateModule.isResubmitAddress;
  }

  set isResubmitAddress(isResubmitting: boolean) {
    ThgCreateModule.setIsResubmitAddress(isResubmitting);
  }

  get isResubmittingTaxnumber(): boolean {
    return ThgCreateModule.isResubmitTaxnumber;
  }

  set isResubmittingTaxnumber(isResubmitting: boolean) {
    ThgCreateModule.setIsResubmitTaxnumber(isResubmitting);
  }

  get isResubmittingBankingData(): boolean {
    return ThgCreateModule.isResubmitBankingInformation;
  }

  set isResubmittingBankingData(isResubmitting: boolean) {
    ThgCreateModule.setIsResubmitBankingInformation(isResubmitting);
  }

  // Update the Store Section
  updateCompany(e: any) {
    ThgCreateModule.setCompany(e.target.value);
  }

  updateTaxnumber(e: any) {
    ThgCreateModule.setTaxnumber(e.target.value);
  }

  updateNumberplate(e: any) {
    ThgCreateModule.setNumberplate(e.target.value);
  }

  updateUserFirstName(e: any) {
    ThgCreateModule.setUser({ firstName: e.target.value });
  }

  updateUserLastName(e: any) {
    ThgCreateModule.setUser({ lastName: e.target.value });
  }

  updateUserPhone(e: any) {
    ThgCreateModule.setContact({ phone: e.target.value });
  }

  updateUserEmail(e: any) {
    ThgCreateModule.setContact({ email: e.target.value.toLowerCase().replace(/\s/g, "") });
  }

  updateUserCity(e: any) {
    ThgCreateModule.setAddress({ city: e.target.value });
  }

  updateUserState(e: any) {
    ThgCreateModule.setAddress({ state: e.target.value });
  }

  updateUserStreet(e: any) {
    ThgCreateModule.setAddress({ street: e.target.value });
  }

  updateUserZip(e: any) {
    ThgCreateModule.setAddress({ zip: e.target.value });
  }

  updateBankingName(e: any) {
    ThgCreateModule.setBanking({ name: e.target.value });
  }

  updateBankingIban(e: any) {
    ThgCreateModule.setBanking({ iban: e.target.value });
  }

  updateBankingBank(e: any) {
    ThgCreateModule.setBanking({ bank: e.target.value });
  }

  //Rules and Form Validation

  valid = false;

  get isDone() {
    return this.valid;
  }

  get numberPlateRules() {
    const rules = [];

    rules.push(requiredRule());
    rules.push(numberplateRule());

    return rules;
  }

  get noNumberRule() {
    const rules = [];

    rules.push(requiredRule());
    rules.push(noNumberRule());

    return rules;
  }

  get zipRules() {
    const rules = [];

    rules.push(germanZipRule());

    return rules;
  }

  get emailRules() {
    const rules = [];

    rules.push(requiredRule());
    rules.push(emailRule());
    rules.push(noWhiteSpaceRule());

    return rules;
  }

  get ibanRules() {
    const rules = [];

    rules.push(requiredRule());
    rules.push(ibanRule());

    return rules;
  }

  get phoneNumberRules() {
    const rules = [];

    rules.push(phoneRule());

    return rules;
  }

  /**
   * redirects to the next screen in the thg stepper
   */
  goNextScreen() {
    if (!this.valid) {
      return;
    }
    const next = ReportModule.nextScreen;
    ReportModule.setStep(next);
    this.$router.push({ path: `/${next}` });
  }
}
